import { addDays, startOfDay, endOfDay, min as minDate, subDays } from 'date-fns';

export const MAX_ANALYTICS_RANGE_DAYS = 30;

export function getRangeDays(start, end) {
  if (!start || !end) return 0;
  return Math.ceil((end - start) / (1000 * 60 * 60 * 24));
}

export function getMaxEndDate(startDate) {
  if (!startDate) return endOfDay(new Date());
  const rangeMax = endOfDay(addDays(startOfDay(startDate), MAX_ANALYTICS_RANGE_DAYS));
  return minDate([rangeMax, endOfDay(new Date())]);
}

/**
 * Apply date picker change with max-range rules.
 * When start moves back beyond max days from end, end auto-adjusts to start + max days (capped at today).
 */
export function applyDateRangeChange(currentRange, field, date) {
  if (!date) return { ok: false };

  const newRange = {
    ...currentRange,
    [field]: field === 'endDate' ? endOfDay(date) : startOfDay(date)
  };

  if (field === 'startDate' && newRange.startDate && newRange.endDate) {
    if (
      newRange.endDate < newRange.startDate
      || getRangeDays(newRange.startDate, newRange.endDate) > MAX_ANALYTICS_RANGE_DAYS
    ) {
      newRange.endDate = getMaxEndDate(newRange.startDate);
    }
  }

  if (field === 'endDate' && newRange.startDate && newRange.endDate) {
    if (newRange.endDate < newRange.startDate) {
      return { ok: false, error: 'End date must be on or after start date' };
    }
    if (getRangeDays(newRange.startDate, newRange.endDate) > MAX_ANALYTICS_RANGE_DAYS) {
      return {
        ok: false,
        error: `Date range cannot exceed ${MAX_ANALYTICS_RANGE_DAYS} days for optimal performance`
      };
    }
  }

  return { ok: true, range: newRange };
}

export function getQuickDateRange(days) {
  return {
    startDate: startOfDay(subDays(new Date(), days)),
    endDate: endOfDay(new Date())
  };
}
